import { IPersonalInfo, IImportData, IOffer } from 'api-paths-cas';

export const hasAgent = (personalInfo: IPersonalInfo, currentOffer: IOffer): boolean =>
  personalInfo.withAgent === 'Agent' || currentOffer.withAgent === true;

export const hasAgentExcludingEnroly = (personalInfo: IPersonalInfo, importData: IImportData, offer: IOffer) => {
  if (hasAgent(personalInfo, offer)) {
    return true;
  }

  const agentNames = [importData.agentName]
    .concat(offer.assignedAgents?.find(agent => agent.id)?.agentName)
    .filter(agentName => agentName !== undefined && agentName !== 'Enroly');

  if (agentNames.length > 0) {
    return true;
  }

  return false;
};
